import { render, staticRenderFns } from "./infographic.vue?vue&type=template&id=a5b76ae8&scoped=true"
import script from "./infographic.vue?vue&type=script&lang=js"
export * from "./infographic.vue?vue&type=script&lang=js"
import style0 from "./infographic.vue?vue&type=style&index=0&id=a5b76ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b76ae8",
  null
  
)

export default component.exports